module.exports = __webpack_public_path__ + "img/Jump Casting9.53431bbd.jpg";